"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.createTokenList = createTokenList;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sdkCore = require("@acala-network/sdk-core");
var _util = require("@polkadot/util");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function extractLocation(key, data) {
  var _data$find, _data$find$, _location$interior$as, _location$interior$as2, _location$interior$as3, _location$interior$as4;
  const location = (_data$find = data.find(item => item[0].args[0].toNumber() === key)) === null || _data$find === void 0 ? void 0 : (_data$find$ = _data$find[1]) === null || _data$find$ === void 0 ? void 0 : _data$find$.unwrapOrDefault();
  if (!location) return;
  const paraChainId = location.interior.isX1 ? location.interior.asX1.asParachain.toNumber() : location.interior.isX3 ? (_location$interior$as = location.interior.asX3.find(item => item.isParachain)) === null || _location$interior$as === void 0 ? void 0 : _location$interior$as.asParachain.toNumber() : location.interior.isX2 ? (_location$interior$as2 = location.interior.asX2.find(item => item.isParachain)) === null || _location$interior$as2 === void 0 ? void 0 : _location$interior$as2.asParachain.toNumber() : undefined;
  const generalIndex = location.interior.isX3 ? (_location$interior$as3 = location.interior.asX3.find(item => item.isGeneralIndex)) === null || _location$interior$as3 === void 0 ? void 0 : _location$interior$as3.asGeneralIndex.toNumber() : undefined;
  const palletInstance = location.interior.isX3 ? (_location$interior$as4 = location.interior.asX3.find(item => item.isPalletInstance)) === null || _location$interior$as4 === void 0 ? void 0 : _location$interior$as4.asPalletInstance.toNumber() : undefined;
  return {
    paraChainId,
    generalIndex,
    palletInstance
  };
}
function createTokenList(tradingPairs, assetMetadata, foreignAssetLocations, configs) {
  const erc20Tokens = Object.fromEntries(assetMetadata.filter(item => {
    return item[0].args[0].isErc20;
  }).map(item => {
    const key = item[0].args[0].asErc20.toString();
    const value = item[1].unwrapOrDefault();
    const name = (0, _sdkCore.createERC20Name)(key);
    const decimals = value.decimals.toNumber();
    return [name, _sdkCore.Token.create(name, {
      type: _sdkCore.TokenType.ERC20,
      fullname: (0, _util.hexToString)(value.name.toHex()),
      display: (0, _util.hexToString)(value.symbol.toHex()),
      symbol: (0, _util.hexToString)(value.symbol.toHex()),
      decimals,
      ed: _sdkCore.FixedPointNumber.fromInner(value.minimalBalance.toString(), decimals)
    })];
  }));
  const stableCoinTokens = Object.fromEntries(assetMetadata.filter(item => {
    return item[0].args[0].isStableAssetId;
  }).map(item => {
    const key = item[0].args[0].asStableAssetId.toNumber();
    const value = item[1].unwrapOrDefault();
    const name = (0, _sdkCore.createStableAssetName)(key);
    const decimals = value.decimals.toNumber();
    return [name, _sdkCore.Token.create(name, {
      type: _sdkCore.TokenType.STABLE_ASSET_POOL_TOKEN,
      fullname: (0, _util.hexToString)(value.name.toHex()),
      display: (0, _util.hexToString)(value.symbol.toHex()),
      symbol: (0, _util.hexToString)(value.symbol.toHex()),
      decimals,
      ed: _sdkCore.FixedPointNumber.fromInner(value.minimalBalance.toString(), decimals)
    })];
  }));
  const foreignTokens = Object.fromEntries(assetMetadata.filter(item => {
    return item[0].args[0].isForeignAssetId;
  }).map(item => {
    const key = item[0].args[0].asForeignAssetId.toNumber();
    const value = item[1].unwrapOrDefault();
    const name = (0, _sdkCore.createForeignAssetName)(key);
    const decimals = value.decimals.toNumber();
    return [name, _sdkCore.Token.create(name, {
      type: _sdkCore.TokenType.FOREIGN_ASSET,
      fullname: (0, _util.hexToString)(value.name.toHex()),
      symbol: (0, _util.hexToString)(value.symbol.toHex()),
      display: (0, _util.hexToString)(value.symbol.toHex()),
      decimals,
      ed: _sdkCore.FixedPointNumber.fromInner(value.minimalBalance.toString(), decimals),
      // TODO: should support other locations
      locations: extractLocation(key, foreignAssetLocations)
    })];
  }));
  const nativeTokens = Object.fromEntries(assetMetadata.filter(item => item[0].args[0].isNativeAssetId).map(item => {
    const value = item[1].unwrapOrDefault();
    const name = (0, _sdkCore.forceToCurrencyName)(item[0].args[0].asNativeAssetId);
    const decimals = value.decimals.toNumber();
    const display = name === 'KUSD' && configs.kusd2ausd ? 'aUSD' : (0, _util.hexToString)(value.symbol.toHex());
    return [name, _sdkCore.Token.create(name, {
      type: _sdkCore.TokenType.BASIC,
      fullname: (0, _util.hexToString)(value.name.toHex()),
      display: display,
      symbol: (0, _util.hexToString)(value.symbol.toHex()),
      decimals,
      ed: _sdkCore.FixedPointNumber.fromInner(value.minimalBalance.toString(), decimals)
    })];
  }));

  // insert foreign tokens to temp
  let temp = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, nativeTokens), foreignTokens), stableCoinTokens), erc20Tokens);

  // inert lcdot to temp
  if (configs.insertLCDOT && temp.DOT) {
    const name = (0, _sdkCore.createLiquidCrowdloanName)(13);
    temp[name] = _sdkCore.Token.create(name, {
      type: _sdkCore.TokenType.LIQUID_CROWDLOAN,
      display: 'lcDOT',
      symbol: 'lcDOT',
      fullname: 'Liquid Crowdloan DOT(13)',
      decimals: temp.DOT.decimals,
      ed: temp.DOT.ed
    });
  }

  // handle dex share at latest
  const dexShareTokens = Object.fromEntries(tradingPairs.filter(item => [item[1].isEnabled]).map(item => {
    const pair = item[0].args[0];
    const token1Name = (0, _sdkCore.forceToCurrencyName)(pair[0]);
    const token2Name = (0, _sdkCore.forceToCurrencyName)(pair[1]);
    const token1 = temp[token1Name];
    const token2 = temp[token2Name];
    const token = _sdkCore.Token.fromTokens(token1, token2, {
      display: `LP ${token1.display}-${token2.display}`
    });
    return [token.name, token];
  }));

  // insert dex share tokens to temp
  temp = _objectSpread(_objectSpread({}, temp), dexShareTokens);
  return temp;
}